import React, { PureComponent } from "react";
import LoaderPanel from "components/LoaderPanel";
import { Query } from "react-apollo";
import BlankState from "./BlankState";
import gql from "graphql-tag";
import { RULE_LIMIT } from "constants/limits";

import RuleList from "../RuleList";

const ruleListQuery = gql`
  query verificationRules($first: Int) {
    verificationRules(first: $first) {
      total
      edges {
        node {
          id
          name
          frequency
          notification {
            recipient
          }
        }
      }
    }
  }
`;

export default class IndexPage extends PureComponent {
  render() {
    return (
      <Query
        query={ruleListQuery}
        variables={{
          first: RULE_LIMIT,
        }}
      >
        {({ data, error, loading }) => {
          if (error) {
            throw error;
          }

          if (loading) {
            return <LoaderPanel />;
          }

          const { verificationRules = { edges: [], total: 0 } } = data;

          const showBlankState = verificationRules.total === 0;

          return showBlankState ? (
            <BlankState />
          ) : (
            <RuleList verificationRules={verificationRules} />
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IndexRoute/IndexPage.js